import { render } from "./funding.vue?vue&type=template&id=57029da4&scoped=true"
import script from "./funding.vue?vue&type=script&lang=js"
export * from "./funding.vue?vue&type=script&lang=js"

import "./funding.vue?vue&type=style&index=0&id=57029da4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57029da4"]])

export default __exports__